
import React from 'react';
import { useCurrency } from '../CurrencyContext';
import { CURRENCIES } from '../../constants';

const CurrencySwitcher: React.FC = () => {
  const { currencyCode, setCurrencyCode } = useCurrency();
  
  return (
    <div className="flex items-center gap-2 bg-slate-50 px-3 py-1.5 rounded-xl border border-slate-200">
      <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Display</span>
      <select 
        value={currencyCode} 
        onChange={(e) => setCurrencyCode(e.target.value)}
        className="bg-transparent border-none text-xs font-black text-slate-900 focus:ring-0 outline-none cursor-pointer"
      >
        {CURRENCIES.map(c => (
          <option key={c.code} value={c.code}>{c.code}</option>
        ))}
      </select>
    </div>
  );
};

export default CurrencySwitcher;
